/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
import inDOM from 'dom-helpers/util/inDOM';
import isIE11 from './isIE11';

let scrollbarWidth;

export const getScrollBarWidth = () => {
  if (!inDOM) return 0;

  if (scrollbarWidth !== undefined) return scrollbarWidth;

  // Create the measurement node
  const scrollDiv = document.createElement('div');

  scrollDiv.style.width = '100px';
  scrollDiv.style.height = '100px';
  scrollDiv.style.overflow = 'scroll';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  document.body.appendChild(scrollDiv);

  // Get the scrollbar width
  scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  if (isIE11) {
    scrollbarWidth = Math.max(0, scrollbarWidth - 2);
  }

  // Delete the DIV
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};
